export default __webpack_public_path__ + "static/media/sepa-2.dafb3726.svg";